import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[StartManyDestinations] ';

export const startManyDestinations = createAction(
  `${prefix} Start Many Destinations`,
  props<{ ids: UUID[] }>()
);

export const startManyDestinationsSuccess = createAction(
  `${prefix} Start Many Destinations Success`,
  props<{ ids: UUID[] }>()
);

export const startManyDestinationsFailure = createAction(
  `${prefix} Start Many Destinations Failure`,
  props<{ error: any }>()
);

export const clearStartManyDestinationsState = createAction(
  `${prefix} Clear Start Many Destinations State`
);
